export const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  select: {
    '& .MuiAutocomplete-tag': {
      display: 'none',
    },
    '& .MuiOutlinedInput-root': {
      maxHeight: '40px',
      pr: '10px !important',
    },
  },
  selectTransform: {
    '& .MuiChip-root': {
      maxHeight: '26px',
      backgroundColor: 'primary.main',
      color: 'common.white',
      '& .MuiSvgIcon-root path': {
        fill: 'white',
        opacity: 0.7,
      },
    },
    '& .MuiOutlinedInput-root': { maxHeight: '40px', pr: '10px !important' },
    '& .MuiChip-root:nth-child(-n+51)': {
      transform: 'translateY(40px)',
      zIndex: '1',
    },
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    marginTop: '4px',
  },
  chip: {
    maxHeight: '26px',
    backgroundColor: 'primary.main',
    color: 'common.white',
    '& .MuiSvgIcon-root path': {
      fill: 'white',
      opacity: 0.7,
    },
  },
};
